import { useState } from "react";
import { IAttachmentFormPayload } from "models/attachments";
import { useCentralApi, useCurrentUser } from "hooks/shared";
import { useSnackbar } from "@sagecentral/core-ui";
import { ValidationSummary } from "components/shared";
type EditAttachmentSignature = (id: number, payload: IAttachmentFormPayload, draft?: boolean) => Promise<any | null>;

type UseEditAttachmentSignature = () => [
    EditAttachmentSignature,
    boolean
];

const useEditAttachment: UseEditAttachmentSignature = () => {

    const { displaySnackbar } = useSnackbar();

    const [working, setWorking] = useState<boolean>(false);
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    const handle = async (id: number, payload: IAttachmentFormPayload, draft?: boolean) => {
        try {
            if (!user || !user.id_token) {
                throw new Error("Invalid user or attachment data");
            }

            var url = draft ? `/api/v3/drafts/workitems/${id}/attachments` : `/api/v3/attachments/${id}`;
            const resp = await fetcher(url, {
                method: 'PUT',
                body: JSON.stringify(payload)
            }, async r => {
                if (r.status === 400) {
                    const data = await r.json();
                        displaySnackbar('warning', <ValidationSummary validationDetail={data} />);
                } else if(!r.ok) {
                    displaySnackbar("error", "We couldn't upload the attachment. Please try again");
                } else {
                    return false;
                }
				
                return true;
            });


            if(resp.ok) {
                displaySnackbar("success", "Success! Attachment uploaded");
            }
            else {
                return null;
            }
            return payload;

        } catch (err) {
            console.error("Error occurred while editing task attachment:", err);
            displaySnackbar("error", "We couldn't upload the attachment. Please try again");
        }

        return null;
    };

    return [
        handle,
        working
    ];
};

export default useEditAttachment;